import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { ExpiredAccountAccessService } from 'app/core/authorization/expired-account-access.service';

@Component({
  selector: 'app-inactive-account-banner',
  templateUrl: './inactive-account-banner.component.html',
  styleUrls: ['./inactive-account-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InactiveAccountBannerComponent {
  public readonly accountName = input<string>('');
  public readonly siteId = input.required<number>();

  private readonly expiredAccountAccess = inject(ExpiredAccountAccessService);
  private readonly router = inject(Router);

  protected stopViewing(): void {
    this.expiredAccountAccess.lock(this.siteId());
    this.router.navigate(['account-expired'], {
      skipLocationChange: true,
      queryParams: { url: this.router.url, b: new Date().getTime() },
    });
  }
}
